var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: _vm.getResumeList,
          expression: "getResumeList",
        },
      ],
      staticClass: "container-fluid infinite-list",
      attrs: {
        "infinite-scroll-immediate": "false",
        "infinite-scroll-disabled": "disabled",
      },
    },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "tool-list" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary btn-sm",
              staticStyle: { "margin-right": "10px" },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [_vm._v(" 返回 ")]
          ),
          _c("CreateResume", {
            staticClass: "tool-list-item create-resume-button",
            on: {
              getResumeList: function ($event) {
                ;(_vm.currentPage = 1),
                  (_vm.personList = []),
                  (_vm.totalPerson = 0),
                  _vm.getResumeList()
              },
            },
          }),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-info btn-sm tool-list-item",
              attrs: {
                type: "button",
                "data-toggle": "modal",
                "data-target": "#uploadModal",
              },
            },
            [_vm._v(" 匯入資料 ")]
          ),
          _vm.personList.length > 0
            ? _c("div", { staticClass: "tool-list-about-card" }, [
                _c(
                  "span",
                  {
                    class: { active: _vm.gridStyle == "block" },
                    on: {
                      click: function ($event) {
                        _vm.gridStyle = "block"
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { fill: "#000", name: "grid-outline" },
                    }),
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    class: { active: _vm.gridStyle == "list" },
                    on: {
                      click: function ($event) {
                        _vm.gridStyle = "list"
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { fill: "#000", name: "list-outline" },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: false, person: person },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "tag",
                      fn: function ({ props }) {
                        return [
                          _c("div", { staticClass: "result" }, [
                            _vm._v(_vm._s(props.InterviewResult)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c("table", [
                            _c("tr", [
                              _c("th", [_vm._v("需求單名稱")]),
                              _c("td", [
                                _vm._v(_vm._s(props.ManpowerDemandName)),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("應徵職務")]),
                              _c("td", [_vm._v(_vm._s(props.Position))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("學歷")]),
                              _c("td", [_vm._v(_vm._s(props.Education[0]))]),
                            ]),
                            _c("tr", [
                              _c("th"),
                              _c("td", [_vm._v(_vm._s(props.Education[1]))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("經歷")]),
                              _c("td", [
                                _vm._v(_vm._s(props.WorkExperience[0])),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th"),
                              _c("td", [
                                _vm._v(_vm._s(props.WorkExperience[1])),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("履歷來源")]),
                              _c("td", [_vm._v(_vm._s(props.Source))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("是否發過感謝函")]),
                              _c("td", [
                                props.SendThankNoticeTime === null
                                  ? _c("span", [_vm._v("否")])
                                  : _c("span", [_vm._v("是")]),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.showDetailModal(props)
                                },
                              },
                            },
                            [_vm._v(" 檢視資訊 ")]
                          ),
                          props.InterviewResult === "尚未邀約" ||
                          props.InterviewResult === "複試"
                            ? _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.clickInterviewInvitation(props)
                                    },
                                  },
                                },
                                [_vm._v(" 面談邀約 ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _c("InterviewMailModal", {
        attrs: { personData: _vm.interviewee },
        on: { updatePerson: _vm.updatePerson },
      }),
      _c("ThanksMailModal", {
        attrs: { personData: _vm.interviewee },
        on: { getLatestSearchResult: _vm.getResumeList },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "uploadModal", tabindex: "-1" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c("p", { staticClass: "form-group" }, [
                      _c(
                        "u",
                        {
                          staticStyle: {
                            color: "midnightblue",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$common.downloadResumeTemplate.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v(" 點擊下載範例檔 ")]
                      ),
                    ]),
                    _vm._m(1),
                    _c(
                      "div",
                      { staticClass: "from-group" },
                      [
                        _vm._m(2),
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            attrs: {
                              action: "",
                              accept: ".xls,.xlsx",
                              "auto-upload": false,
                              "show-file-list": false,
                              "on-change": _vm.uploadFile,
                              limit: 1,
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("點擊上傳")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 0
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.showInterviewRecord
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.detailCurrentPage = 1
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    name: "message-circle-outline",
                                    fill: "#FFF",
                                  },
                                }),
                                _vm._v(" 面談紀錄 "),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.showAppointmentRecord
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.detailCurrentPage = 2
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    name: "clipboard-outline",
                                    fill: "#FFF",
                                  },
                                }),
                                _vm._v(" 任用單 "),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("履歷")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item text-right" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$common.downloadResumePDF(
                                                      _vm.ResumeType,
                                                      _vm.ResumeId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 下載 PDF ")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 1
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("面談紀錄")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("InterviewRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 2
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("任用單")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("AppointmentRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("匯入資料")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "form-group" }, [
      _c("span", { staticClass: "mark" }, [
        _vm._v("* 檔案限制：[檔名].xlsx、[檔名].xls"),
      ]),
      _c("br"),
      _c("span", { staticClass: "mark" }, [_vm._v("* 大小限制：10MB 以下")]),
      _c("br"),
      _c("span", { staticClass: "mark" }, [
        _vm._v("* 上傳前請確認是否符合格式"),
      ]),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _c("span", { staticClass: "mark" }, [_vm._v("*")]),
      _vm._v("檔案"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }